import { FormControl, Button } from '@mui/material';
import React, { ChangeEvent, useCallback } from 'react';

type Props = {
	label: string;
	setValue: (value: string) => void;
};

const ImageControl: React.FC<Props> = ({ setValue, label }) => {
	const onChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const reader = new FileReader();
			reader.onload = () => {
				if (reader.result) setValue(reader.result.toString());
			};
			const ele = e.target as HTMLInputElement;
			if (ele?.files?.[0]) reader.readAsDataURL(ele.files[0]);
		},
		[setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset">
			<Button variant="contained" color="primary" component="label">
				<input type="file" accept="image/*" hidden onChange={onChange} />
				{label}
			</Button>
		</FormControl>
	);
};

const MemoImageControl = React.memo(ImageControl);

export { MemoImageControl as ImageControl };
